import { withRouter } from 'react-router-dom';

function NonAuthLayout(props) {
	return props.children;
}

export default withRouter(NonAuthLayout);
